module.exports = __webpack_public_path__ + "img/filter.e2cc5c48.svg";